import Banner from '@rio-cloud/rio-uikit/Banner';
import Button from '@rio-cloud/rio-uikit/Button';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { getCustomerCenterPath } from '../../common/routes';
import { CustomerCenterTab } from '../types';

interface Props {
    onShowInteractiveGuide: () => void;
}

export const PaymentMethodRequiredInfoPanel = ({ onShowInteractiveGuide }: Props) => (
    <div className='margin-bottom-15'>
        <Banner show dismissible={false} initialAnimation={false}>
            <Banner.Page>
                <Banner.Icon className='text-size-14'>
                    <span className='uikit-icon icon-info-sign text-size-200pct' />
                </Banner.Icon>
                <Banner.Content
                    title={<FormattedMessage id='marketplace.contracts.paymentMethodRequired.title' />}
                    actions={<Banner.Actions />}
                >
                    <FormattedMessage
                        id='marketplace.contracts.paymentMethodRequired.text'
                        values={{
                            p: (chunks: ReactNode) => <p>{chunks}</p>,
                            paymentMethods: (chunks: ReactNode) => (
                                <a
                                    href={getCustomerCenterPath(CustomerCenterTab.PAYMENT_METHODS)}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    data-track-ga-event-trigger='click'
                                    data-track-ga-event-category='marketplace'
                                    data-track-ga-event-action='paymentMethodRequiredPaymentMethods_click'
                                    data-track-ga-event-label='link::marketplace.contracts.paymentMethodRequired.paymentMethods'
                                >
                                    {chunks}
                                </a>
                            ),
                            interactiveGuide: (chunks: ReactNode) => (
                                <Button
                                    bsStyle={Button.PRIMARY}
                                    variant={Button.VARIANT_LINK_INLINE}
                                    onClick={onShowInteractiveGuide}
                                    autoTrackingKey='marketplace.contracts.paymentMethodRequired.interactiveGuide'
                                >
                                    {chunks}
                                </Button>
                            ),
                        }}
                    />
                </Banner.Content>
            </Banner.Page>
        </Banner>
    </div>
);
